import PropTypes from 'prop-types';

export const refPropsTypes = (type) =>
  PropTypes.oneOfType([
    PropTypes.shape({
      current: type,
    }),
    PropTypes.func,
  ]);
